import Table from 'pages/challenges/Table';

const Challenges = () => {
  return <Table />;
};

export default Challenges;
